/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m13.1758183 17.0782354-11.94448004-14.44087641c-.53928194-.65199187-.0755526-1.63735899.77056702-1.63735899h28.00000002c.8461196 0 1.3098489.98536712.770567 1.63735899l-11.9444801 14.44087641v9.2695907c0 .2652165-.1053568.5195704-.2928932.7071068l-3.6521739 3.6521739c-.6299649.6299648-1.7071068.1837981-1.7071068-.7071068zm14.7012115-14.0782354h-23.750249l10.8196045 13.0809019c.1482975.1792916.229433.404684.229433.637359v10.8675255l1.6521739-1.6521739v-9.2153516c0-.232675.0811356-.4580674.229433-.637359z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;